import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TextsService } from '@app/services/texts.service';
import { KeyValue, WebformService } from '@app/services/webform.service';
import { Subscription } from 'rxjs';
import { CardEntry } from '../card/card.component';

@Component({
  standalone: false,
  selector: 'webform-summary-uvg',
  templateUrl: './uvg.component.html',
  styleUrls: ['./uvg.component.scss'],
})
export class UvgComponent implements OnInit, OnDestroy {
  contractData!: CardEntry[];
  personalData!: CardEntry[];
  calcAction: Function = () => {
    this.#webform.setCurrentPage(0);
    document
      ?.querySelector('webform-steps')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  personalAction: Function = () => {
    this.#webform.setCurrentPage(1);
    document
      ?.querySelector('webform-steps')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  #formDataSub!: Subscription;

  readonly #webform = inject(WebformService);
  readonly #textsService = inject(TextsService);
  readonly #cdr = inject(ChangeDetectorRef);

  async ngOnInit(): Promise<void> {
    const id: string = this.#webform.formId;
    this.#formDataSub = this.#webform.formData.subscribe(async (formData: KeyValue) => {
      this.contractData = [
        {
          icon: 'money_bag',
          label: await this.texts('summary_payment_method_title', 'Zahlungsart'),
          text: await this.texts('summary_payment_method_text', 'Zahlung per Rechnung'),
        },
        {
          icon: 'money_coin',
          label: await this.texts('summary_payment_interval_title', 'Zahlungshäufigkeit'),
          text: await this.texts('summary_payment_interval_text', 'Jährlich'),
        },
      ];

      const { address, address_2, city, postal_code }: any =
        formData[`${id}--leadapi_pd_address`];
      this.personalData = [
        {
          icon: 'face',
          label: await this.texts('summary_personal_name', 'Name'),
          text: `${formData[`${id}--leadapi_pd_vorname`]} ${formData[`${id}--leadapi_pd_name`]}`,
        },
        {
          icon: 'cake_birthday_on',
          label: await this.texts('summary_personal_birthdate', 'Geburtsdatum'),
          text: formData[`${id}--leadapi_pd_geburtsdatum`],
        },
        {
          icon: 'house',
          label: await this.texts('summary_personal_address', 'Adresse'),
          text: `${address || ''} ${address_2 || ''}, ${postal_code || ''} ${city || ''}`,
        },
        {
          icon: 'mail_electronic',
          label: await this.texts('summary_personal_email', 'E-Mail Adresse'),
          text: formData[`${id}--leadapi_pd_email`],
        },
        {
          icon: 'telephone',
          label: await this.texts('summary_personal_phone', 'Telefonnummer'),
          text: formData[`${id}--leadapi_pd_telefon_privat`],
        },
      ];
      this.#cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    if (this.#formDataSub) this.#formDataSub.unsubscribe();
  }

  async texts(id: string, fallback: string): Promise<string> {
    return await this.#textsService.getText(id, 'primcalc', fallback);
  }
}
